import React from "react";

export default () => (
  <div className="Modal__modal">
    <h5 className="Modal__title">Configure Ada Messenger</h5>
    <div className="Modal__body">
      <div className="Modal__body__container">
        <div className="Modal__content">
          There are currently no configuration options for Ada Messenger.
        </div>
      </div>
    </div>
  </div>
);
